<template>
  <div id="app" class="ihlp-width-100">
    <layout-top-home v-if="islogin&&!isUpgrade&&layoutName=='home'"></layout-top-home>
    <layout-top-tab v-else-if="islogin&&!isUpgrade&&layoutName=='tab'"></layout-top-tab>
    <no-permission ref="noPermission" v-if="noPermission"></no-permission>
    <upgrade ref="upgrade" :msg="upgradeMsg" v-if="isUpgrade"></upgrade>
  </div>
</template>

<script>
import layoutTopTab from "./layout/Layout_top_tab";
import layoutTopHome from "./layout/Layout_top_home";
import noPermission from "./page/home/noPermission";
import upgrade from "./page/home/upgrade";
import { mapGetters, mapState } from "vuex";
import { Dialog } from 'vant';
let axios = require("axios");
export default {
  components: {
    layoutTopTab,
    layoutTopHome,
    noPermission,
    upgrade
  },
  computed: {
    ...mapGetters({
      layoutName: "base/getLayoutName"
    })
  },
  name: "app",
  data() {
    return {
      islogin: false,
      userId:"",
      noPermission: false,
      isUpgrade: false,
      upgradeMsg: "",
      whiteList:"" //白名单
    };
  },
  created() {
    // this.upgrade();
    this.init();
  },
  mounted(){
  sessionStorage.setItem("WxCodeUrl",location.href)
},
  methods: {
    upgrade() {
      axios.defaults.crossDomain = true;
      axios.defaults.withCredentials = true;
      let self = this;
      let cfgObj = {
        method: "POST",
        url: "lookUpManage/listPermissionTypeAndSys",
        data: { classifyCode: "ihlp.system.upgrade" },
        params: null,
        baseURL: window.location.origin + "/accountzuul/permission/",
        withCredentials: false,
        headers: { "Content-Type": "application/json;charset=UTF-8" }
      };
        //调用服务
      axios(cfgObj)
        .then(function(res) {
          if (res.data.code === 200) {
            let result = res.data.result || [],isUpgraded=false;
            for(let i =0;i<result.length;i++){
              let item=result[i]
              if(item.itemCode=='1001'){
                let updateDate=item.itemDesc||"";
                updateDate=updateDate.split("--");
                let beginDate=updateDate[0]||"",
                endDate=updateDate[1]||"";
                if(updateDate!=""&&new Date(beginDate)<new Date()&&new Date()<new Date(endDate)){
                  //系统升级
                  self.upgradeMsg = item.itemName;
                  isUpgraded=true;
                  break;
                }
              }
              //添加系统升级白名单配置
              if(item.itemCode=='1003'){
                self.whiteList=item.itemName||""
              }
            }
            self.isUpgrade = isUpgraded;
            if(self.islogin&&self.whiteList.indexOf(self.userId)>-1){
              self.isUpgrade = false;
            }
          }
        })
        .catch(function(err) {
        });
    },
    init() {
      let self = this,
        iview = {
          Modal: self.$Modal,
          Message: self.$Message,
          Dialog: Dialog
        };
      self.$utils.init(iview);
      let pse = self.$api.init(iview);
      pse.then(self.loginSuccess, self.loginError);
    },
    loginSuccess(data) {
      let self = this,
      result=data.result;
      self.islogin = true;
      // self.userId=result.userId||result[0].userId;
      // this.$store.commit("userInfo/setUserInfoUserBase", result);
      // self.$api.post({
      //   sc: "permission",
      //   // url:'userManage/listUserRoleProgram',
      //   url: "authorityRange/getUserRoleProgramAclentry/hd",
      //   success: function(r) {
      //     // self.getUserChannel()
      //     //设置用户基础数据
      //     let result = r.result || {},
      //       list = result.permissionList || [];
      //     //无权限处理，跳转到无权限页面
      //     if (!result.userRoleProgramVO) {
      //       self.noPermission = true;
      //       self.$nextTick(function() {
      //         self.$refs.noPermission.init();
      //       });
      //     } else {
      //       let pList = [];
      //       if (list.length > 0) {
      //         list.filter(item => pList.push(item.rpCode));
      //       }
      //       self.$store.commit("userInfo/setUserPermission", {
      //         service: pList
      //       });
      //       self.islogin = true;
      //       if(self.isUpgrade&&self.whiteList.indexOf(self.userId)>-1){
      //         self.isUpgrade = false;
      //       }
      //       self.$store.commit("userInfo/setIslogin", true);
      //       //获取会员的一些别名
      //       self.$store.dispatch("base/getMemberAlias")
      //     }
      //   }
      // });
    },
    loginError(err) {
      if (err.errorCode == "A0001") {
        Dialog({
          title: "提示",
          message: err.errorMessage
        });
      }
    },
    getUserChannel() {
      let self = this;
      //获取用户店铺数据
      self.$api.post({
        sc: "merchant",
        url: "channelManage/listByChannelAccountUuid",
        success: function(r) {
          let list = r.result || [];
          self.$store.commit("userInfo/setUserChannel", list);
          self.islogin = true;
        },
        error: function(r) {
          self.islogin = true;
          // this.$Modal.error({
          //   title: "获取店铺数据失败!",
          //   content: err.errorMessage
          // });
        }
      });
    }
  }
};
</script>
 <style>
  .ivu-message {
    z-index: 1000000 !important;
  }
 </style>



// WEBPACK FOOTER //
// src/App.vue